import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'trueFalseToYesNo',
})
export class TrueFalseToYesNoPipe implements PipeTransform {
  transform(value: string): string {
    if (value === 'false') { return 'Нет'; }
    if (value === 'true') { return 'Да'; }
    return value;
  }
}
